import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";
import { Badge } from "../../components/ui/badge";
import { motion } from "framer-motion";
import {
  Shield,
  Users,
  Briefcase,
  Building2,
  BarChart3,
  Settings,
  Lock
} from "lucide-react";

export default function Admin() {
  return (
    <div className="min-h-screen p-4 md:p-8">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="mb-8"
        >
          <div className="flex items-center gap-3 mb-2">
            <Shield className="w-8 h-8 text-indigo-600" />
            <h1 className="text-4xl font-bold">Admin Dashboard</h1>
          </div>
          <Badge className="bg-amber-100 text-amber-700">
            Coming Soon - Backend Integration Pending
          </Badge>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {[
            { icon: Users, title: "User Management", desc: "Manage all platform users" },
            { icon: Briefcase, title: "Job Postings", desc: "Monitor and moderate jobs" },
            { icon: Building2, title: "Companies", desc: "Manage employer accounts" },
            { icon: BarChart3, title: "Analytics", desc: "Platform insights & metrics" },
            { icon: Settings, title: "System Settings", desc: "Configure platform settings" },
            { icon: Lock, title: "Security", desc: "Access controls & permissions" }
          ].map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <Card className="h-full hover:shadow-xl transition-all duration-300 border-2">
                <CardHeader>
                  <div className="w-12 h-12 bg-gradient-to-br from-indigo-100 to-purple-100 rounded-xl flex items-center justify-center mb-4">
                    <item.icon className="w-6 h-6 text-indigo-600" />
                  </div>
                  <CardTitle>{item.title}</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-gray-600">{item.desc}</p>
                  <Badge variant="secondary" className="mt-4">Protected Route</Badge>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>

        <Card className="mt-8 bg-gradient-to-br from-indigo-50 to-purple-50 border-2">
          <CardContent className="p-8 text-center">
            <Lock className="w-12 h-12 mx-auto mb-4 text-indigo-600" />
            <h3 className="text-2xl font-bold mb-2">Admin Access Required</h3>
            <p className="text-gray-600 mb-4">
              This area will be available once backend authentication and admin roles are implemented.
            </p>
            <Badge className="bg-indigo-600 text-white">Integration Phase 8</Badge>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}